module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="modal fade" id="tipsModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">\n    <div class="modal-dialog">\n        <div class="modal-content">\n            <div class="modal-header">\n                ' +
((__t = (terms.tip[language])) == null ? '' : __t) +
' <span id="tipsProgress"></span> <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button> &nbsp\n            </div>\n            <div class="modal-body">\n                <div id="tipContent">\n                </div>\n                <br>\n                <div class="btn-toolbar" role="toolbar">\n                    <button type="button" id="previousTip" class="btn" style="display:none">' +
((__t = (terms.previousTip[language])) == null ? '' : __t) +
'</button>\n                    <button type="button" id="nextTip" class="btn">' +
((__t = (terms.nextTip[language])) == null ? '' : __t) +
'</button>\n                    <button type="button" id="gotIt" class="btn" style="display:none">' +
((__t = (terms.gotIt[language])) == null ? '' : __t) +
'</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>';

}
return __p
}